import React from 'react';
import { cssVars } from '@/app/styles';
import { VERIFICATION_STATUES } from '@/constants';
import { gridRowHeightInteger } from '@/list/list-constants';
import { VerifiedIcon } from '@/widgets/components/verified-icon';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: ${gridRowHeightInteger}px;
  line-height: 1;
`;

const AddrGroupName = styled.span`
  margin-top: 2px;
  border-bottom: solid 2px rgba(89, 126, 247, 0.25);
`;
const AddrGroupWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

const AddrLeafWrapper = styled.div`
  color: ${cssVars.textColors.light3};
`;

const VerifiedPropertyIcon = styled(VerifiedIcon)`
  font-size: 18px;
  flex-shrink: 0;
`;

function getHighestLevelOfVerificationFromNodes(nodes = []) {
  const verifiedStatusesInNodes = new Set(
    nodes.map(({ verifiedStatus }) => verifiedStatus).filter(Boolean)
  );

  if (verifiedStatusesInNodes.has(VERIFICATION_STATUES.VERIFIED))
    return VERIFICATION_STATUES.VERIFIED;
  if (verifiedStatusesInNodes.has(VERIFICATION_STATUES.PENDING_VERIFICATION))
    return VERIFICATION_STATUES.PENDING_VERIFICATION;
  return VERIFICATION_STATUES.UNVERIFIED;
}

export function AddrCell({ data, node }) {
  const rowData = data || node?.allLeafChildren[0]?.data;
  const leafCellContent = <AddrLeafWrapper>{rowData?.address}</AddrLeafWrapper>;

  const verifiedStatus = node.group
    ? getHighestLevelOfVerificationFromNodes(node?.allLeafChildren)
    : rowData?.verifiedStatus;

  return (
    <Wrapper>
      {!node.group ? (
        leafCellContent
      ) : (
        <AddrGroupWrapper>
          <AddrGroupName>{rowData?.address}</AddrGroupName> (
          {node?.allLeafChildren.length})
          <VerifiedPropertyIcon verifiedStatus={verifiedStatus} />
        </AddrGroupWrapper>
      )}
    </Wrapper>
  );
}
